import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, Input } from '@angular/core';
import { FaefResultado } from '../../model/faef';

@Component({
  selector: 'app-modal-balanco-patrimonial',
  templateUrl: './modal-balanco-patrimonial.component.html',
  styleUrls: ['./modal-balanco-patrimonial.component.scss']
})
export class ModalBalancoPatrimonialComponent {

  @Input() model: FaefResultado;

  constructor(public modal: BsModalRef) { }

}
